export default __webpack_public_path__ + "static/media/TF_2.0783eb7d.gif";